import { useGetSession } from '@actions';
import { ReactComponent as BackSignIcon } from '@assets/icons/back-sign.svg';
import AgoraSpinner from '@components/V3/Utils/AgoraSpinner';
import Button from '@components/V4/Button';
import Modal from '@components/V4/Modal/Modal';
import QualityScoreBadge from '@components/V4/QualityScore/QualityScoreBadge';
import SessionDetailsSection from './SessionDetailsSection/SessionDetailsSection';
import SessionTabsSection, { SessionTab } from './SessionTabsSection/SessionTabsSection';

interface SessionDetailsPageProps {
  sessionId: string;
  isBackButtonActive?: boolean;
  onGoBack?: () => void;
  tab?: SessionTab;
}

const SessionDetailsPage = (props: SessionDetailsPageProps) => {
  const { sessionId, isBackButtonActive = false, onGoBack, tab } = props;

  const { data: session, isLoading } = useGetSession(sessionId);

  return isLoading || !session ? (
    <AgoraSpinner />
  ) : (
    <>
      <Modal.Header className="relative font-raleway text-xl font-bold text-center mb-6">
        {isBackButtonActive && (
          <Button
            icon={<BackSignIcon />}
            className="absolute top-0 left-6"
            variant="secondary"
            onClick={onGoBack}
            buttonText="Back"
          />
        )}

        <h3>Session Details - {session?.name}</h3>
        <h3>{`${session?.mentor ?? 'n/a'} / ${session?.student ?? 'n/a'}`}</h3>
        <div className="mt-3 flex items-center justify-center gap-2 text-sm font-normal">
          <span className="text-customGrey">AI session score:</span>
          <QualityScoreBadge
            score={session?.qualityScoring?.score}
            size="large"
            emptyText="Not graded"
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <SessionDetailsSection session={session} />
        <SessionTabsSection session={session} tab={tab} />
      </Modal.Body>
    </>
  );
};

export default SessionDetailsPage;
